import { render } from "./FolloweeButton.vue?vue&type=template&id=0b6a286c"
import script from "./FolloweeButton.vue?vue&type=script&lang=js"
export * from "./FolloweeButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__